type PayrollFileSource = {
  s3_file_url?: string | null;
  uploaded_files?: Array<{
    file_url?: string | null;
    file_name?: string | null;
  }>;
};

type PayrollDisplaySource = PayrollFileSource & {
  title?: string | null;
  year?: number;
  month?: number;
  input_mode?: string | null;
  display_type?: string | null;
};

export const buildPayrollFileName = (employeeName: string | undefined, year: number, month: number): string => {
  const safeEmployeeName = employeeName?.trim() || "급여명세서";
  return `${safeEmployeeName}_${year}년_${month}월_급여명세서.pdf`;
};

export const getPayrollFileUrl = (payroll?: PayrollFileSource | null): string => {
  if (!payroll) return "";

  const uploadedFileUrl = payroll.uploaded_files?.[0]?.file_url;
  return (uploadedFileUrl || payroll.s3_file_url || "").trim();
};

export const isProbablyMockPayrollFileUrl = (fileUrl: string): boolean => {
  if (!fileUrl) return true;

  return (
    fileUrl.includes("s3...") ||
    fileUrl.includes("signed-or-public") ||
    /\/payrolls\/branch-\d+\/employee-\d+\.pdf(?:\?|$)/i.test(fileUrl)
  );
};

export const isPayrollFileOnly = (payroll?: PayrollDisplaySource | null): boolean => {
  if (!payroll) return false;
  return payroll.input_mode === "file_only" || payroll.display_type === "file";
};

export const getPayrollTypeLabel = (payroll?: PayrollDisplaySource | null): string => {
  return isPayrollFileOnly(payroll) ? "파일" : "직접작성";
};

export const getPayrollTitle = (payroll: PayrollDisplaySource): string => {
  const title = payroll.title?.trim();
  if (title) return title;

  if (payroll.year && payroll.month) {
    return `${payroll.year}년 ${payroll.month}월 급여명세`;
  }

  return "급여명세";
};
